export default __webpack_public_path__ + "static/media/Resume.626130c8.pdf";